
import { Coordinates, PropertyInfo } from "../types";

/**
 * Henter matrikkelinformasjon og grunneierstatus (Statskog vs Privat).
 */
export const fetchPropertyInfo = async (coords: Coordinates): Promise<PropertyInfo> => {
  let property: PropertyInfo = {
    kommunenavn: "Ukjent",
    kommunenummer: "0000",
    gnr: null,
    bnr: null,
    fullstendigMatrikkel: "UAVKLART",
    eierform: 'Ukjent',
    ownerName: "Privat/Annen grunn"
  };

  try {
    // 1. Hent kommuneinfo
    const kommuneUrl = `https://ws.geonorge.no/kommuneinfo/v1/punkt?nord=${coords.latitude}&ost=${coords.longitude}&koordsys=4326`;
    const kommuneRes = await fetch(kommuneUrl, { headers: { 'Accept': 'application/json' } });
    if (kommuneRes.ok) {
      const kData = await kommuneRes.json();
      property.kommunenavn = kData.kommunenavn || "Ukjent";
      property.kommunenummer = kData.kommunenummer || "0000";
    }

    // 2. Hent Matrikkel (Gnr/Bnr)
    // API: https://ws.geonorge.no/eiendom/v1/punkt — returnerer { eiendom: [...], metadata: {...} }
    const eiendomUrl = `https://ws.geonorge.no/eiendom/v1/punkt?nord=${coords.latitude}&ost=${coords.longitude}&koordsys=4326`;
    const eiendomRes = await fetch(eiendomUrl, { headers: { 'Accept': 'application/json' } });

    if (eiendomRes.ok) {
      const eData = await eiendomRes.json();
      const eiendommer = eData.eiendom;
      if (Array.isArray(eiendommer) && eiendommer.length > 0) {
        const enhet = eiendommer[0];
        property.gnr = enhet.gardsnummer || null;
        property.bnr = enhet.bruksnummer || null;
        if (enhet.gardsnummer) {
          property.fullstendigMatrikkel = `${property.kommunenummer}-${enhet.gardsnummer}/${enhet.bruksnummer}`;
          if (property.eierform !== 'Statskog') {
            property.ownerName = `Privat/Annen grunn (Gnr ${enhet.gardsnummer}, Bnr ${enhet.bruksnummer})`;
            property.eierform = 'Privat';
          }
        }
      }
    }

    return property;
  } catch (error) {
    console.error("Feil ved matrikkel-oppslag:", error);
    return property;
  }
};
